import { useState, useEffect } from 'react';
import { atom, useAtom } from 'jotai';
import FloatingPopup from './FloatingPopup';
import ConsultationModal from './ConsultationModal';
import TrialExpiringModal from './TrialExpiringModal';
import LockedFeatureModal from './LockedFeatureModal';

/** モーダル開閉状態のatom（ヘッダーなど外部から開くために共有） */
export const trialConsultationModalAtom = atom(false);

/** ロック機能クリック時のモーダル開閉状態 */
export const trialLockedFeatureModalAtom = atom(false);

type Props = {
  trialDaysRemaining: number | null;
};

/** トライアルプラン向け相談ポップアップ（フローティング + モーダル） */
export default function TrialConsultationPopup({ trialDaysRemaining }: Props) {
  const [modalOpen, setModalOpen] = useAtom(trialConsultationModalAtom);
  const [lockedModalOpen, setLockedModalOpen] = useAtom(trialLockedFeatureModalAtom);
  const [popupVisible, setPopupVisible] = useState(false);

  // 残り5日以下かどうかで表示するモーダルを切り替え
  const isExpiringSoon = trialDaysRemaining !== null && trialDaysRemaining <= 5;

  useEffect(() => {
    const timer = setTimeout(() => setPopupVisible(true), 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <FloatingPopup
        visible={popupVisible}
        onClick={() => setModalOpen(true)}
        trialDaysRemaining={trialDaysRemaining}
      />
      {isExpiringSoon ? (
        <TrialExpiringModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          trialDaysRemaining={trialDaysRemaining}
        />
      ) : (
        <ConsultationModal open={modalOpen} onClose={() => setModalOpen(false)} />
      )}
      <LockedFeatureModal open={lockedModalOpen} onClose={() => setLockedModalOpen(false)} />
    </>
  );
}
